module.exports = __webpack_public_path__ + "static/media/i4c-future.a8e27a25.svg";